"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Image = _interopRequireDefault(require("ol/layer/Image"));

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _TreeContextMenu = _interopRequireDefault(require("../TreeContextMenu/TreeContextMenu"));

var _NewImageWMSLayerButton = _interopRequireDefault(require("../../button/layer/new/NewImageWMSLayerButton/NewImageWMSLayerButton"));

var _NewTileWMSLayerButton = _interopRequireDefault(require("../../button/layer/new/NewTileWMSLayerButton/NewTileWMSLayerButton"));

var _NewGroupLayerButton = _interopRequireDefault(require("../../button/layer/new/NewGroupLayerButton/NewGroupLayerButton"));

var _NewOSMLayerButton = _interopRequireDefault(require("../../button/layer/new/NewOSMLayerButton/NewOSMLayerButton"));

var _EditLayerButton = _interopRequireDefault(require("../../button/layer/edit/EditLayerButton/EditLayerButton"));

var _RemoveLayerButton = _interopRequireDefault(require("../../button/layer/remove/RemoveLayerButton/RemoveLayerButton"));

var _ClearAllFeaturesButton = _interopRequireDefault(require("../../button/feature/ClearAllFeaturesButton/ClearAllFeaturesButton"));

var _WmsGetFeatureInfoButton = _interopRequireDefault(require("../../button/wms/WmsGetFeatureInfoButton/WmsGetFeatureInfoButton"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeLayerContextMenu = function TreeLayerContextMenu(_ref) {
  var map = _ref.map,
      node = _ref.node,
      xPos = _ref.xPos,
      yPos = _ref.yPos,
      showMenu = _ref.showMenu;
  if (!node) return null;

  var createAddWMSLayerButton = function createAddWMSLayerButton(layer) {
    if (layer && layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FileAddOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewImageWMSLayerButton.default, {
          size: "small",
          type: "text",
          map: map,
          parentLayerGroup: layer,
          wndStyle: {
            visibility: 'visible',
            width: 700,
            maxHeight: 500
          },
          children: "New WMS Layer"
        })
      }, "ADD_WMS_LAYER");
    }

    return null;
  };

  var createAddTileWMSLayerButton = function createAddTileWMSLayerButton(layer) {
    if (layer && layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FileAddOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewTileWMSLayerButton.default, {
          size: "small",
          type: "text",
          map: map,
          parentLayerGroup: layer,
          wndStyle: {
            visibility: 'visible',
            width: 700,
            maxHeight: 500
          },
          children: "New Tile WMS Layer"
        })
      }, "ADD_TILE_WMS_LAYER");
    }

    return null;
  }; // const createAddWMSLayerButton = (layer) => {
  //     if(layer && layer instanceof OlLayerGroup) {
  //         return(
  //             <Menu.Item icon={<FileAddOutlined   />}>
  //                 <AddImageWMSLayerButton 
  //                     size="small"
  //                     type="text"
  //                     map={map} 
  //                     layerGroup={layer}
  //                     wndStyle={{visibility: 'visible', width: 700, maxHeight: 500}}
  //                 >
  //                     Add WMS Layer
  //                 </AddImageWMSLayerButton>
  //             </Menu.Item>
  //         );
  //     }
  //     return null;
  // }


  var createAddGroupLayerButton = function createAddGroupLayerButton(layer) {
    if (layer && layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FileAddOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewGroupLayerButton.default, {
          size: "small",
          type: "text",
          map: map,
          parentLayerGroup: layer,
          wndStyle: {
            visibility: 'visible',
            width: 700,
            maxHeight: 500
          },
          children: "New Group Layer"
        })
      }, "ADD_GROUP_LAYER");
    }

    return null;
  };

  var createAddOSMLayerButton = function createAddOSMLayerButton(layer) {
    if (layer && layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FileAddOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewOSMLayerButton.default, {
          size: "small",
          type: "text",
          map: map,
          parentLayerGroup: layer,
          wndStyle: {
            visibility: 'visible',
            width: 700,
            maxHeight: 500
          },
          children: "New OSM Layer"
        })
      }, "ADD_OSM_LAYER");
    }

    return null;
  }; // const createAddGroupLayerButton = (layer) => {
  //     if(layer && layer instanceof OlLayerGroup) {
  //         return(
  //             <Menu.Item icon={<FileAddOutlined   />}>
  //                 <AddGroupLayerButton 
  //                     size="small"
  //                     type="text"
  //                     map={map} 
  //                     layerGroup={layer}
  //                     wndStyle={{visibility: 'visible', width: 700, maxHeight: 500}}
  //                 >
  //                     Add Group Layer
  //                 </AddGroupLayerButton>
  //             </Menu.Item>
  //         );
  //     }
  //     return null;
  // }

  /*
  const createAddLayerSubMenu = (layer) => {
      if(layer && layer instanceof OlLayerGroup) {
          return(
              <Menu.SubMenu title="Add Layer" icon={<FileAddOutlined   />}>
                  {createAddWMSLayerButton(layer)}
                  {createAddGroupLayerButton(layer)}
              </Menu.SubMenu>
          );
      }
      return null;
  }
  */
  // const createAddLayerItemGroup = (layer) => {
  //     if(layer && layer instanceof OlLayerGroup) {
  //         return(
  //             <Menu.ItemGroup title="Add Layer">
  //                 {/* <FileAddTwoTone/> */}
  //                 {createAddWMSLayerButton(layer)}
  //                 {createAddGroupLayerButton(layer)}
  //             </Menu.ItemGroup>
  //         );
  //     }
  //     return null;
  // }


  var createEditLayerButton = function createEditLayerButton(layer) {
    if (layer) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.EditOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditLayerButton.default, {
          size: "small",
          type: "text",
          wndStyle: {
            visibility: 'visible',
            width: 700,
            maxHeight: 500
          },
          layer: layer,
          children: "Edit Layer"
        })
      }, "EDIT_LAYER");
    }
  };

  var createRemoveLayerButton = function createRemoveLayerButton(layer) {
    if (layer && layer !== map.getLayerGroup()) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DeleteOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemoveLayerButton.default, {
          size: "small",
          type: "text",
          map: map,
          layer: node.ol_layer,
          children: "Remove Layer"
        })
      }, "REMOVE_LAYER");
    }

    return null;
  };

  var createClearLayerButton = function createClearLayerButton(layer) {
    if (layer instanceof _Vector.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ClearOutlined, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClearAllFeaturesButton.default, {
          size: "small",
          type: "text",
          map: map,
          vectorLayer: node.ol_layer,
          children: "Clear Layer"
        })
      }, "CLEAR_LAYER");
    }

    return null;
  };

  var createGetFeatureInfoButton = function createGetFeatureInfoButton(map, layer) {
    if (layer instanceof _Image.default || layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircleOutlined, {}),
        selectable: false ? 0 : 1 //https://github.com/styled-components/styled-components/issues/1198
        ,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WmsGetFeatureInfoButton.default, {
          size: "small",
          type: "text",
          map: map,
          layers: [layer],
          wndStyle: {
            visibility: 'visible',
            width: 600
          },
          children: "Feature Info"
        })
      }, "GET_FEATURE_INFO");
    }

    return null;
  };

  var overlay = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Menu, {
    mode: "vertical",
    children: [createEditLayerButton(node.ol_layer), createRemoveLayerButton(node.ol_layer), createClearLayerButton(node.ol_layer), createGetFeatureInfoButton(map, node.ol_layer), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Divider, {}), createAddGroupLayerButton(node.ol_layer), createAddWMSLayerButton(node.ol_layer), createAddTileWMSLayerButton(node.ol_layer), createAddOSMLayerButton(node.ol_layer)]
  }); // overlay = (
  //     <React.Fragment>
  //         {createEditLayerButton(node.ol_layer)}
  //         {createRemoveLayerButton(node)}
  //         {createClearLayerButton(node.ol_layer)}
  //         {createGetFeatureInfoButton(map, node.ol_layer)}
  //         {createAddWMSLayerButton(node.ol_layer)}
  //         {createAddGroupLayerButton(node.ol_layer)}
  //     </React.Fragment>
  // );
  // overlay = (
  //     <Menu mode="vertical">
  //         <Menu.Item>
  //             {createEditLayerButton(node.ol_layer)}
  //         </Menu.Item>
  //         <Menu.Item>
  //             {createRemoveLayerButton(node)} 
  //         </Menu.Item>
  //         <Menu.Item>
  //             {createClearLayerButton(node.ol_layer)}
  //         </Menu.Item>
  //         <Menu.Item>
  //             {createGetFeatureInfoButton(map, node.ol_layer)}    
  //         </Menu.Item>
  //         <Menu.Divider/>
  //         <Menu.SubMenu title="Add Layer">
  //             <Menu.Item>
  //                 {createAddWMSLayerButton(node.ol_layer)}
  //             </Menu.Item>
  //             <Menu.Item>
  //                 {createAddGroupLayerButton(node.ol_layer)}
  //             </Menu.Item>
  //         </Menu.SubMenu>
  //     </Menu>
  // );

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TreeContextMenu.default, {
    overlay: overlay,
    node: node,
    xPos: xPos,
    yPos: yPos,
    showMenu: showMenu
  });
};

var _default = TreeLayerContextMenu;
exports.default = _default;